import React from "react";
import { IControlledMutator } from "sonobello.utilities.react";

import PhoneNumberField from "../../../../Components/Helpers/PhoneNumberField";

/** Adds onChangeValue and isDuplicate. */
export interface IIntroPhoneNumberField extends IControlledMutator<string | undefined> {
  onChangeValue: React.Dispatch<string | undefined>;
  isDuplicate: boolean;
}

/** PhoneNumberField styled for Intro. */
const IntroPhoneNumberField: React.FC<IIntroPhoneNumberField> = ({ value, onChange, onChangeValue, isDuplicate }) => {
  return (
    <PhoneNumberField
      customerKey="phoneNumber"
      label="Mobile Phone"
      error={isDuplicate}
      helperText={isDuplicate ? "Number is a duplicate." : undefined}
      value={value}
      onChange={changedValue => onChangeValue(changedValue)}
      onAccepted={acceptedValue => onChange(acceptedValue)}
      fullWidth={false}
      sx={{ maxWidth: "12rem" }}
    />
  );
};

export default IntroPhoneNumberField;
